import React from 'react';
import { AdditionFact } from '../data/curriculum';

export type MissingPart = 'sum' | 'addend1' | 'addend2';

interface FactDisplayProps {
  fact: AdditionFact;
  showAnswer?: boolean;
  size?: 'normal' | 'large';
  missingPart?: MissingPart;
}

const FactDisplay: React.FC<FactDisplayProps> = ({ fact, showAnswer = true, size = 'normal', missingPart = 'sum' }) => {
  const textClass = size === 'large' ? 'text-5xl' : 'text-3xl';

  const renderAddend1 = () => {
    if (missingPart === 'addend1') {
      return showAnswer
        ? <span className="text-green-600">{fact.addend1}</span>
        : <span className="text-indigo-400">?</span>;
    }
    return <span>{fact.addend1}</span>;
  };

  const renderAddend2 = () => {
    if (missingPart === 'addend2') {
      return showAnswer
        ? <span className="text-green-600">{fact.addend2}</span>
        : <span className="text-indigo-400">?</span>;
    }
    return <span>{fact.addend2}</span>;
  };

  const renderSum = () => {
    if (missingPart === 'sum') {
      return showAnswer
        ? <span className="text-green-600">{fact.sum}</span>
        : <span className="text-indigo-400">?</span>;
    }
    return <span>{fact.sum}</span>;
  };

  return (
    <div className={`${textClass} font-bold text-gray-800 tracking-wide`}>
      {renderAddend1()}
      <span className="mx-2 text-indigo-500">+</span>
      {renderAddend2()}
      <span className="mx-2">=</span>
      {renderSum()}
    </div>
  );
};

export default FactDisplay;
